import { Container, TitleBar } from 'bitmovin-player-ui';
import { createAirPlayToggleButton, createCastToggleButton, createFullscreenToggleButton, createPictureInPictureToggleButton, createSettingsButton, createVolumeToggleButton } from './buttons';
import { createSettingsPanel } from '../settingspanel';
export function createTopBar(player) {
    const settingsPanel = createSettingsPanel(player);
    return new TitleBar({
        components: [
            new Container({
                components: [
                    createAirPlayToggleButton(),
                    createCastToggleButton(),
                    createSettingsButton(settingsPanel),
                    settingsPanel,
                    createPictureInPictureToggleButton(player),
                    createFullscreenToggleButton(player),
                    createVolumeToggleButton(player)
                ],
                cssClasses: ['controlbar-top', 'controlbar-small']
            })
        ],
        cssClasses: ['titlebar-small']
    });
}
